/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit ImageSeries/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFormat from 'Data/format.js'
import * as fromHelpers from './helpers.js'
import ButtonIconLabel from 'DesignSystem/ButtonIconLabel/index'
import ImageIcon from 'DesignSystem/Svgs/ImageIcon/index'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function ImageSeries({
  children,
  viewPath = "/DesignSystem/ImageComparison/Content/Actions/Choose/ChooseImageAction/Content/Content/ImageSeries/Content/ImageSeries"
  
}) {
let imageSerieValueData = fromData.useDataFormat({ viewPath,
context: 'image_serie',
format: fromFormat.getImageSeriesName,
})
let imageSerieIdValueData = fromData.useDataValue({ viewPath,
context: 'image_serie',
path: 'id',
})
let comparisonActionImageSeriesIdValueData = fromData.useDataValue({ viewPath,
context: 'comparison_action',
path: 'image_series_id',
})
let aggregateData = fromAggregate.equals(imageSerieIdValueData, comparisonActionImageSeriesIdValueData)
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let onClick = fromHelpers.useOnClick({
  children,
  viewPath
  
})
  return (<React.Fragment
>
<div
  data-testid="ImageSeries.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<ButtonIconLabel
  viewPath={`${viewPath}/ButtonIconLabel`}
 marginTop={dtSpaceXxs}
 data="image_serie"
 format="/Data/format.js getImageSeriesName"
 text={imageSerieValueData}
 onClick={onClick}
 data="image_serie.id"
 data="comparison_action.image_series_id"
 aggregate="/Data/aggregate.js equals"
 isSelected={aggregateData}
 overflow="hidden"
 textOverflow="ellipses"
 maxWidth={300}
>
{childProps => (
<ImageIcon
{...childProps}
  viewPath={`${viewPath}/ImageIcon`}
 width={16}
 height={16}
 stroke="rgba(0,0,0,0.7)"
/>
)}
</ButtonIconLabel>
</div>
{children}
</React.Fragment>)
}